const BUCKET = 'product-images';

export function storagePublicUrl(supabaseUrl, storagePath) {
  return `${supabaseUrl}/storage/v1/object/public/${BUCKET}/${storagePath}`;
}

// Adapts a products row (with embedded product_images) to the shape the
// existing components expect: images[{url, alt_text, is_primary}], thumbnail.
export function mapProductRow(row, supabaseUrl) {
  // Real product photos come first; Etsy marketing-collage slides (flagged in
  // the admin) sort to the end so cards and galleries lead with photography.
  const imageRows = [...(row.product_images ?? [])].sort(
    (a, b) => (a.is_marketing === b.is_marketing ? a.position - b.position : a.is_marketing ? 1 : -1)
  );
  const images = imageRows.map((img, i) => ({
    url: storagePublicUrl(supabaseUrl, img.storage_path),
    alt_text: img.alt_text || row.name,
    is_primary: i === 0,
    is_marketing: img.is_marketing || false,
  }));
  return {
    ...row,
    categories: row.categories ?? [],
    tags: row.tags ?? [],
    materials: row.materials ?? [],
    images,
    shortDescription: row.short_description,
    longDescription: row.long_description,
  };
}
